import _JSON$stringify from 'babel-runtime/core-js/json/stringify';
import _extends from 'babel-runtime/helpers/extends';
import _regeneratorRuntime from 'babel-runtime/regenerator';

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(courseViewedSaga),
    _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(courseAssignedSaga),
    _marked3 = /*#__PURE__*/_regeneratorRuntime.mark(sequenceViewedSaga),
    _marked4 = /*#__PURE__*/_regeneratorRuntime.mark(startActivityStepSaga),
    _marked5 = /*#__PURE__*/_regeneratorRuntime.mark(activityStepChangedSaga),
    _marked6 = /*#__PURE__*/_regeneratorRuntime.mark(pronunciationItemAttemptedSaga),
    _marked7 = /*#__PURE__*/_regeneratorRuntime.mark(goToNextPronunciationItemSaga),
    _marked8 = /*#__PURE__*/_regeneratorRuntime.mark(skipActivityStepSaga),
    _marked9 = /*#__PURE__*/_regeneratorRuntime.mark(activityStepReviewSaga),
    _marked10 = /*#__PURE__*/_regeneratorRuntime.mark(activityStepTryAgainSelectedSaga),
    _marked11 = /*#__PURE__*/_regeneratorRuntime.mark(activityStepCheckAnswer),
    _marked12 = /*#__PURE__*/_regeneratorRuntime.mark(activityStepDismissedSaga),
    _marked13 = /*#__PURE__*/_regeneratorRuntime.mark(activityStepMediaStarted),
    _marked14 = /*#__PURE__*/_regeneratorRuntime.mark(activityStepMediaPaused),
    _marked15 = /*#__PURE__*/_regeneratorRuntime.mark(activityStepMediaFinished),
    _marked16 = /*#__PURE__*/_regeneratorRuntime.mark(activityStepUploadStarted),
    _marked17 = /*#__PURE__*/_regeneratorRuntime.mark(activityStepUploadFinished),
    _marked18 = /*#__PURE__*/_regeneratorRuntime.mark(activityStepUploadFailed),
    _marked19 = /*#__PURE__*/_regeneratorRuntime.mark(activityStepCalibrationStarted),
    _marked20 = /*#__PURE__*/_regeneratorRuntime.mark(activityStepCalibrationPerformed),
    _marked21 = /*#__PURE__*/_regeneratorRuntime.mark(activityStepCalibrationErrored),
    _marked22 = /*#__PURE__*/_regeneratorRuntime.mark(activityStepCalibrationFinished),
    _marked23 = /*#__PURE__*/_regeneratorRuntime.mark(learningActivityInterruptedSaga),
    _marked24 = /*#__PURE__*/_regeneratorRuntime.mark(learningActivityResumedSaga),
    _marked25 = /*#__PURE__*/_regeneratorRuntime.mark(stepStatusSagas);

import { call, put, select, takeEvery } from 'redux-saga/effects';
import { stepStatusActions, stepStatusSelectors, COURSE_VIEWED, COURSE_ASSIGNED, SEQUENCE_VIEWED, START_ACTIVITY_STEP, ACTIVITY_STEP_REVIEW, SKIP_ACTIVITY_STEP, UPDATE_STEP_STATUS, PRONUNCIATION_ITEM_ATTEMPTED, GO_TO_NEXT_PRONUNCIATION_ITEM, ACTIVITY_STEP_TRY_AGAIN_SELECTED, SUBMIT_ACTIVITY_STEP, ACTIVITY_STEP_DISMISSED, ACTIVITY_STEP_MEDIA_STARTED, ACTIVITY_STEP_MEDIA_PAUSED, ACTIVITY_STEP_MEDIA_FINISHED, ACTIVITY_STEP_UPLOAD_STARTED, ACTIVITY_STEP_UPLOAD_FINISHED, ACTIVITY_STEP_UPLOAD_FAILED, LEARNING_ACTIVITY_INTERRUPTED, LEARNING_ACTIVITY_RESUMED } from './step-status-reducer';
import { sreActions } from '@rosetta/react-sre';
import { getReduxStore, getCourseSelectors, getLogger } from '../../init';
import progressManagerHelper from '../../progress/progress-manager-helper';
import { progressActions } from '../../progress/redux/progress-reducer';
import { progressStepTypes } from '../../progress/progress-constants';

function courseViewedSaga(_ref) {
  var courseId = _ref.payload.courseId;
  var newContext;
  return _regeneratorRuntime.wrap(function courseViewedSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return put(stepStatusActions.progressReadyForCourse(null));

        case 2:
          progressManagerHelper.getProgressTracker().courseViewed(courseId);
          newContext = { courseId: courseId };
          _context.next = 6;
          return put(stepStatusActions.setStepStatusContext(newContext));

        case 6:
          progressManagerHelper.getProgressTracker().ensureCourseReady(courseId, function () {
            getReduxStore().dispatch(stepStatusActions.progressReadyForCourse(courseId));
            getReduxStore().dispatch(progressActions.fetchLastSequenceAttempted(courseId));
          }, progressManagerHelper.dispatchMpThrowableToRedux('CourseViewed()'));

        case 7:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function courseAssignedSaga(_ref2) {
  var courseId = _ref2.payload.courseId;
  return _regeneratorRuntime.wrap(function courseAssignedSaga$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return put(stepStatusActions.setCourseBeingAssignedId(courseId));

        case 2:
          progressManagerHelper.getProgressManager().onCourseAssigned(courseId, function () {
            getReduxStore().dispatch(stepStatusActions.setCourseBeingAssignedId(null));
          }, progressManagerHelper.dispatchMpThrowableToRedux('CourseAssigned()'));

        case 3:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function sequenceViewedSaga(_ref3) {
  var _ref3$payload = _ref3.payload,
      courseId = _ref3$payload.courseId,
      sequenceId = _ref3$payload.sequenceId,
      sequenceVersion = _ref3$payload.sequenceVersion;
  var stepStatusContext, sequenceIdentifierModel, newContext;
  return _regeneratorRuntime.wrap(function sequenceViewedSaga$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return select(stepStatusSelectors.getStepStatusContext);

        case 2:
          stepStatusContext = _context3.sent;

          if (!(!stepStatusContext || courseId !== stepStatusContext.courseId || sequenceId !== stepStatusContext.sequenceId || sequenceVersion !== stepStatusContext.sequenceVersion)) {
            _context3.next = 9;
            break;
          }

          sequenceIdentifierModel = progressManagerHelper.getProgressDomainModelFactory().toSequenceIdentifierModel(courseId, sequenceId, sequenceVersion);

          progressManagerHelper.getProgressTracker().sequenceViewed(sequenceIdentifierModel);
          newContext = { courseId: courseId, sequenceId: sequenceId, sequenceVersion: sequenceVersion };
          _context3.next = 9;
          return put(stepStatusActions.setStepStatusContext(newContext));

        case 9:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

function startActivityStepSaga(_ref4) {
  var payload = _ref4.payload;
  var stepStatusContext, newStepStatusContext, activityStepIdentifier, isAssessment;
  return _regeneratorRuntime.wrap(function startActivityStepSaga$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return select(stepStatusSelectors.getStepStatusContext);

        case 2:
          stepStatusContext = _context4.sent;

          if (!(stepStatusContext && (stepStatusContext.activityStepId && stepStatusContext.activityStepId !== payload.activityStepId || stepStatusContext.activityId && stepStatusContext.activityId !== payload.activityId))) {
            _context4.next = 6;
            break;
          }

          _context4.next = 6;
          return call(activityStepDismissedSaga);

        case 6:
          newStepStatusContext = {
            courseId: payload.courseId,
            sequenceId: payload.sequenceId,
            sequenceVersion: payload.version,
            activityId: payload.activityId,
            activityStepId: payload.activityStepId,
            activitySubStepId: payload.activitySubStepId
          };
          _context4.next = 9;
          return put(stepStatusActions.setStepStatusContext(newStepStatusContext));

        case 9:
          _context4.next = 11;
          return put(stepStatusActions.setActivityStepReadyForClose(false));

        case 11:
          activityStepIdentifier = progressManagerHelper.stepStatusContextToActivityStepIdentifierModel(newStepStatusContext);
          // assessments are not in courses, so we can't call this next one for them since the progress-mp
          //  lib depends on there being a courseId in the activityStepIdentifier

          _context4.next = 14;
          return select(getCourseSelectors().getIsAssessment);

        case 14:
          isAssessment = _context4.sent;

          if (!isAssessment) {
            progressManagerHelper.getProgressTracker().activityStepStarted(activityStepIdentifier);
          }

        case 16:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

// activityStepChangedSaga() is for handling unscored substep completion and updating
//  the stepStatusContext for steps with substeps
function activityStepChangedSaga(_ref5) {
  var payload = _ref5.payload;
  var stepStatusContext, newStepStatusContext, isNewSubstep, activityStepIdentifier, answerFormat;
  return _regeneratorRuntime.wrap(function activityStepChangedSaga$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          if (!(payload.activitySubStepId && payload.progressStepType !== progressStepTypes.PRONUNCIATION_PHONEME)) {
            _context5.next = 18;
            break;
          }

          _context5.next = 3;
          return select(stepStatusSelectors.getStepStatusContext);

        case 3:
          stepStatusContext = _context5.sent;

          if (!stepStatusContext) {
            _context5.next = 18;
            break;
          }

          newStepStatusContext = _extends({}, stepStatusContext);
          isNewSubstep = payload.activitySubStepId !== stepStatusContext.activitySubStepId;

          if (!isNewSubstep) {
            _context5.next = 11;
            break;
          }

          newStepStatusContext.activitySubStepId = payload.activitySubStepId;
          _context5.next = 11;
          return put(stepStatusActions.setStepStatusContext(newStepStatusContext));

        case 11:
          _context5.next = 13;
          return put(stepStatusActions.setActivityStepReadyForClose(false));

        case 13:
          activityStepIdentifier = progressManagerHelper.stepStatusContextToActivityStepIdentifierModel(newStepStatusContext);

          progressManagerHelper.getProgressTracker().activityStepStarted(activityStepIdentifier);
          answerFormat = progressManagerHelper.buildActivitySpecificAnswer({
            progressStepType: payload.progressStepType,
            correct: true
          });

          progressManagerHelper.getProgressTracker().activityStepAnswerSubmitted(activityStepIdentifier, answerFormat);
          // immediately start again so we continue to collect time spent
          progressManagerHelper.getProgressTracker().activityStepStarted(activityStepIdentifier);

        case 18:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this);
}

// this is called when a user attempts to pronounce a pronunciation item
function pronunciationItemAttemptedSaga(_ref6) {
  var payload = _ref6.payload;
  var stepStatusContext, activityStepIdentifier, answerFormat;
  return _regeneratorRuntime.wrap(function pronunciationItemAttemptedSaga$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return select(stepStatusSelectors.getStepStatusContext);

        case 2:
          stepStatusContext = _context6.sent;
          activityStepIdentifier = progressManagerHelper.stepStatusContextToActivityStepIdentifierModel(stepStatusContext);
          answerFormat = progressManagerHelper.buildActivitySpecificAnswer({
            progressStepType: progressStepTypes.PRONUNCIATION_PHONEME,
            correct: payload.correct
          });

          progressManagerHelper.getProgressTracker().activityStepAnswerSubmitted(activityStepIdentifier, answerFormat);
          // immediately start again so we continue to collect time spent
          progressManagerHelper.getProgressTracker().activityStepStarted(activityStepIdentifier);

        case 7:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked6, this);
}

// handle moving to a different pronunciation item
function goToNextPronunciationItemSaga(action) {
  var stepStatusContext, nextItemId, newStepStatusContext, activityStepIdentifier;
  return _regeneratorRuntime.wrap(function goToNextPronunciationItemSaga$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return select(stepStatusSelectors.getStepStatusContext);

        case 2:
          stepStatusContext = _context7.sent;
          nextItemId = action.payload.nextItemId;

          if (!(nextItemId && nextItemId.indexOf('section') === -1)) {
            _context7.next = 14;
            break;
          }

          newStepStatusContext = _extends({}, stepStatusContext, {
            activitySubStepId: nextItemId
          });
          _context7.next = 8;
          return put(stepStatusActions.setStepStatusContext(newStepStatusContext));

        case 8:
          _context7.next = 10;
          return put(stepStatusActions.setActivityStepReadyForClose(false));

        case 10:
          activityStepIdentifier = progressManagerHelper.stepStatusContextToActivityStepIdentifierModel(newStepStatusContext);

          progressManagerHelper.getProgressTracker().activityStepStarted(activityStepIdentifier);
          _context7.next = 16;
          break;

        case 14:
          _context7.next = 16;
          return put(stepStatusActions.setActivityStepReadyForClose(true));

        case 16:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked7, this);
}

function skipActivityStepSaga() {
  var stepStatusContext, activityStepIdentifierModel;
  return _regeneratorRuntime.wrap(function skipActivityStepSaga$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return select(stepStatusSelectors.getStepStatusContext);

        case 2:
          stepStatusContext = _context8.sent;
          activityStepIdentifierModel = progressManagerHelper.stepStatusContextToActivityStepIdentifierModel(stepStatusContext);

          progressManagerHelper.getProgressTracker().activityStepSkipped(activityStepIdentifierModel);

        case 5:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked8, this);
}

function activityStepReviewSaga() {
  var stepStatusContext, activityStepIdentifierModel;
  return _regeneratorRuntime.wrap(function activityStepReviewSaga$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return select(stepStatusSelectors.getStepStatusContext);

        case 2:
          stepStatusContext = _context9.sent;
          activityStepIdentifierModel = progressManagerHelper.stepStatusContextToActivityStepIdentifierModel(stepStatusContext);

          progressManagerHelper.getProgressTracker().activityStepReview(activityStepIdentifierModel);

        case 5:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked9, this);
}

function activityStepTryAgainSelectedSaga() {
  var stepStatusContext, activityStepIdentifier;
  return _regeneratorRuntime.wrap(function activityStepTryAgainSelectedSaga$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return put(stepStatusActions.setActivityStepReadyForClose(false));

        case 2:
          _context10.next = 4;
          return select(stepStatusSelectors.getStepStatusContext);

        case 4:
          stepStatusContext = _context10.sent;
          activityStepIdentifier = progressManagerHelper.stepStatusContextToActivityStepIdentifierModel(stepStatusContext);

          progressManagerHelper.getProgressTracker().activityStepRetrySelected(activityStepIdentifier);

        case 7:
        case 'end':
          return _context10.stop();
      }
    }
  }, _marked10, this);
}

function activityStepCheckAnswer(_ref7) {
  var payload = _ref7.payload;
  var stepStatusContext, activityStepReadyForClose, activityStepIdentifierModel, answerFormat;
  return _regeneratorRuntime.wrap(function activityStepCheckAnswer$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          _context11.next = 2;
          return select(stepStatusSelectors.getStepStatusContext);

        case 2:
          stepStatusContext = _context11.sent;
          _context11.next = 5;
          return select(stepStatusSelectors.getActivityStepReadyForClose);

        case 5:
          activityStepReadyForClose = _context11.sent;

          if (!(stepStatusContext && !activityStepReadyForClose)) {
            _context11.next = 13;
            break;
          }

          activityStepIdentifierModel = progressManagerHelper.stepStatusContextToActivityStepIdentifierModel(stepStatusContext);

          getLogger().info('activityStepComplete(): ', activityStepIdentifierModel);
          answerFormat = progressManagerHelper.buildActivitySpecificAnswer(payload);

          progressManagerHelper.getProgressTracker().activityStepAnswerSubmitted(activityStepIdentifierModel, answerFormat);
          _context11.next = 13;
          return put(stepStatusActions.setActivityStepReadyForClose(true));

        case 13:
        case 'end':
          return _context11.stop();
      }
    }
  }, _marked11, this);
}

function activityStepDismissedSaga() {
  var stepStatusContext, completeActivityStepOnDismissPayload, activityStepReadyForClose, activityIdentifierModel, newStepStatusContext;
  return _regeneratorRuntime.wrap(function activityStepDismissedSaga$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          _context12.next = 2;
          return select(stepStatusSelectors.getStepStatusContext);

        case 2:
          stepStatusContext = _context12.sent;

          if (!stepStatusContext.activityId) {
            _context12.next = 23;
            break;
          }

          _context12.next = 6;
          return select(stepStatusSelectors.getCompleteActivityStepOnDismissPayload);

        case 6:
          completeActivityStepOnDismissPayload = _context12.sent;

          if (!completeActivityStepOnDismissPayload) {
            _context12.next = 14;
            break;
          }

          _context12.next = 10;
          return put(stepStatusActions.setActivityStepReadyForClose(false));

        case 10:
          _context12.next = 12;
          return call(activityStepCheckAnswer, { payload: completeActivityStepOnDismissPayload });

        case 12:
          _context12.next = 14;
          return put(stepStatusActions.setCompleteActivityStepOnDismissPayload(null));

        case 14:
          _context12.next = 16;
          return select(stepStatusSelectors.getActivityStepReadyForClose);

        case 16:
          activityStepReadyForClose = _context12.sent;

          if (!activityStepReadyForClose) {
            activityIdentifierModel = progressManagerHelper.stepStatusContextToActivityIdentifierModel(stepStatusContext);

            progressManagerHelper.getProgressTracker().activityAborted(activityIdentifierModel);
          }

          newStepStatusContext = _extends({}, stepStatusContext, {
            activityId: null,
            activityStepId: null,
            activitySubStepId: null
          });
          _context12.next = 21;
          return put(stepStatusActions.setStepStatusContext(newStepStatusContext));

        case 21:
          _context12.next = 23;
          return put(stepStatusActions.setActivityStepReadyForClose(false));

        case 23:
        case 'end':
          return _context12.stop();
      }
    }
  }, _marked12, this);
}

function activityStepMediaStarted(action) {
  var stepStatusContext, activityStepIdentifierModel;
  return _regeneratorRuntime.wrap(function activityStepMediaStarted$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          _context13.next = 2;
          return select(stepStatusSelectors.getStepStatusContext);

        case 2:
          stepStatusContext = _context13.sent;
          activityStepIdentifierModel = progressManagerHelper.stepStatusContextToActivityStepIdentifierModel(stepStatusContext);

          progressManagerHelper.getProgressTracker().activityStepMediaStarted(activityStepIdentifierModel, action.payload.mediaDurationMs, action.payload.currentPlaybackTimeMs);

        case 5:
        case 'end':
          return _context13.stop();
      }
    }
  }, _marked13, this);
}

function activityStepMediaPaused(_ref8) {
  var currentPlaybackTimeMs = _ref8.payload.currentPlaybackTimeMs;
  var stepStatusContext, activityStepIdentifierModel;
  return _regeneratorRuntime.wrap(function activityStepMediaPaused$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          _context14.next = 2;
          return select(stepStatusSelectors.getStepStatusContext);

        case 2:
          stepStatusContext = _context14.sent;
          activityStepIdentifierModel = progressManagerHelper.stepStatusContextToActivityStepIdentifierModel(stepStatusContext);

          progressManagerHelper.getProgressTracker().activityStepMediaPaused(activityStepIdentifierModel, currentPlaybackTimeMs);

        case 5:
        case 'end':
          return _context14.stop();
      }
    }
  }, _marked14, this);
}

function activityStepMediaFinished() {
  var activityStepReadyForClose, stepStatusContext, activityStepIdentifierModel;
  return _regeneratorRuntime.wrap(function activityStepMediaFinished$(_context15) {
    while (1) {
      switch (_context15.prev = _context15.next) {
        case 0:
          _context15.next = 2;
          return select(stepStatusSelectors.getActivityStepReadyForClose);

        case 2:
          activityStepReadyForClose = _context15.sent;

          if (activityStepReadyForClose) {
            _context15.next = 9;
            break;
          }

          _context15.next = 6;
          return select(stepStatusSelectors.getStepStatusContext);

        case 6:
          stepStatusContext = _context15.sent;
          activityStepIdentifierModel = progressManagerHelper.stepStatusContextToActivityStepIdentifierModel(stepStatusContext);

          progressManagerHelper.getProgressTracker().activityStepMediaFinished(activityStepIdentifierModel);

        case 9:
        case 'end':
          return _context15.stop();
      }
    }
  }, _marked15, this);
}

function activityStepUploadStarted(payload) {
  var stepStatusContext, activityStepIdentifierModel;
  return _regeneratorRuntime.wrap(function activityStepUploadStarted$(_context16) {
    while (1) {
      switch (_context16.prev = _context16.next) {
        case 0:
          _context16.next = 2;
          return select(stepStatusSelectors.getStepStatusContext);

        case 2:
          stepStatusContext = _context16.sent;
          activityStepIdentifierModel = progressManagerHelper.stepStatusContextToActivityStepIdentifierModel(stepStatusContext);

          progressManagerHelper.getProgressTracker().activityStepUploadStarted(activityStepIdentifierModel);

        case 5:
        case 'end':
          return _context16.stop();
      }
    }
  }, _marked16, this);
}

function activityStepUploadFinished(payload) {
  var stepStatusContext, activityStepIdentifierModel;
  return _regeneratorRuntime.wrap(function activityStepUploadFinished$(_context17) {
    while (1) {
      switch (_context17.prev = _context17.next) {
        case 0:
          _context17.next = 2;
          return select(stepStatusSelectors.getStepStatusContext);

        case 2:
          stepStatusContext = _context17.sent;
          activityStepIdentifierModel = progressManagerHelper.stepStatusContextToActivityStepIdentifierModel(stepStatusContext);

          progressManagerHelper.getProgressTracker().activityStepUploadFinished(activityStepIdentifierModel);

        case 5:
        case 'end':
          return _context17.stop();
      }
    }
  }, _marked17, this);
}

function activityStepUploadFailed(payload) {
  var stepStatusContext, activityStepIdentifierModel;
  return _regeneratorRuntime.wrap(function activityStepUploadFailed$(_context18) {
    while (1) {
      switch (_context18.prev = _context18.next) {
        case 0:
          _context18.next = 2;
          return select(stepStatusSelectors.getStepStatusContext);

        case 2:
          stepStatusContext = _context18.sent;
          activityStepIdentifierModel = progressManagerHelper.stepStatusContextToActivityStepIdentifierModel(stepStatusContext);

          progressManagerHelper.getProgressTracker().activityStepUploadFailed(activityStepIdentifierModel);

        case 5:
        case 'end':
          return _context18.stop();
      }
    }
  }, _marked18, this);
}

function activityStepCalibrationStarted() {
  var stepStatusContext, activityStepIdentifierModel;
  return _regeneratorRuntime.wrap(function activityStepCalibrationStarted$(_context19) {
    while (1) {
      switch (_context19.prev = _context19.next) {
        case 0:
          _context19.next = 2;
          return select(stepStatusSelectors.getStepStatusContext);

        case 2:
          stepStatusContext = _context19.sent;
          activityStepIdentifierModel = progressManagerHelper.stepStatusContextToActivityStepIdentifierModel(stepStatusContext);

          progressManagerHelper.getProgressTracker().sessionInterrupted();
          progressManagerHelper.getProgressTracker().activityStepCalibrationStarted(activityStepIdentifierModel);

        case 6:
        case 'end':
          return _context19.stop();
      }
    }
  }, _marked19, this);
}

function activityStepCalibrationPerformed(_ref9) {
  var qualityStr = _ref9.payload.qualityStr;
  return _regeneratorRuntime.wrap(function activityStepCalibrationPerformed$(_context20) {
    while (1) {
      switch (_context20.prev = _context20.next) {
        case 0:
          _context20.next = 2;
          return put(stepStatusActions.setMicQualityStr(qualityStr));

        case 2:
          _context20.next = 4;
          return put(stepStatusActions.setMicCalibrationError(null));

        case 4:
        case 'end':
          return _context20.stop();
      }
    }
  }, _marked20, this);
}

function activityStepCalibrationErrored(_ref10) {
  var error = _ref10.payload.error;
  return _regeneratorRuntime.wrap(function activityStepCalibrationErrored$(_context21) {
    while (1) {
      switch (_context21.prev = _context21.next) {
        case 0:
          _context21.next = 2;
          return put(stepStatusActions.setMicQualityStr(null));

        case 2:
          _context21.next = 4;
          return put(stepStatusActions.setMicCalibrationError(error));

        case 4:
        case 'end':
          return _context21.stop();
      }
    }
  }, _marked21, this);
}

function activityStepCalibrationFinished() {
  var stepStatusContext, activityStepIdentifierModel, micQualityStr, shamelessHack, micCalibrationError, _shamelessHack;

  return _regeneratorRuntime.wrap(function activityStepCalibrationFinished$(_context22) {
    while (1) {
      switch (_context22.prev = _context22.next) {
        case 0:
          _context22.next = 2;
          return select(stepStatusSelectors.getStepStatusContext);

        case 2:
          stepStatusContext = _context22.sent;
          activityStepIdentifierModel = progressManagerHelper.stepStatusContextToActivityStepIdentifierModel(stepStatusContext);
          _context22.next = 6;
          return select(stepStatusSelectors.getMicQualityStr);

        case 6:
          micQualityStr = _context22.sent;

          if (!micQualityStr) {
            _context22.next = 12;
            break;
          }

          shamelessHack = progressManagerHelper.getProgressDomainModelFactory().toCalibrationResult('OK');

          progressManagerHelper.getProgressTracker().activityStepCalibrationFinished(activityStepIdentifierModel, shamelessHack);
          _context22.next = 18;
          break;

        case 12:
          _context22.next = 14;
          return select(stepStatusSelectors.getMicCalibrationError);

        case 14:
          micCalibrationError = _context22.sent;

          getLogger().debug('micCalibrationError=', _JSON$stringify(micCalibrationError));

          //TODO: Find out from Peter what he's passing....
          _shamelessHack = progressManagerHelper.getProgressDomainModelFactory().toCalibrationResult('OK');

          progressManagerHelper.getProgressTracker().activityStepCalibrationFinished(activityStepIdentifierModel, _shamelessHack);

        case 18:
          progressManagerHelper.getProgressTracker().sessionResumed();

        case 19:
        case 'end':
          return _context22.stop();
      }
    }
  }, _marked22, this);
}

function learningActivityInterruptedSaga() {
  var stepStatusContext;
  return _regeneratorRuntime.wrap(function learningActivityInterruptedSaga$(_context23) {
    while (1) {
      switch (_context23.prev = _context23.next) {
        case 0:
          _context23.next = 2;
          return select(stepStatusSelectors.getStepStatusContext);

        case 2:
          stepStatusContext = _context23.sent;

          if (stepStatusContext) {
            progressManagerHelper.getProgressTracker().sessionInterrupted();
          }

        case 4:
        case 'end':
          return _context23.stop();
      }
    }
  }, _marked23, this);
}

function learningActivityResumedSaga() {
  var stepStatusContext;
  return _regeneratorRuntime.wrap(function learningActivityResumedSaga$(_context24) {
    while (1) {
      switch (_context24.prev = _context24.next) {
        case 0:
          _context24.next = 2;
          return select(stepStatusSelectors.getStepStatusContext);

        case 2:
          stepStatusContext = _context24.sent;

          if (stepStatusContext) {
            progressManagerHelper.getProgressTracker().sessionResumed();
          }

        case 4:
        case 'end':
          return _context24.stop();
      }
    }
  }, _marked24, this);
}

export function stepStatusSagas() {
  return _regeneratorRuntime.wrap(function stepStatusSagas$(_context25) {
    while (1) {
      switch (_context25.prev = _context25.next) {
        case 0:
          _context25.next = 2;
          return takeEvery(COURSE_VIEWED, courseViewedSaga);

        case 2:
          _context25.next = 4;
          return takeEvery(COURSE_ASSIGNED, courseAssignedSaga);

        case 4:
          _context25.next = 6;
          return takeEvery(SEQUENCE_VIEWED, sequenceViewedSaga);

        case 6:
          _context25.next = 8;
          return takeEvery(START_ACTIVITY_STEP, startActivityStepSaga);

        case 8:
          _context25.next = 10;
          return takeEvery(SKIP_ACTIVITY_STEP, skipActivityStepSaga);

        case 10:
          _context25.next = 12;
          return takeEvery(ACTIVITY_STEP_REVIEW, activityStepReviewSaga);

        case 12:
          _context25.next = 14;
          return takeEvery(UPDATE_STEP_STATUS, activityStepChangedSaga);

        case 14:
          _context25.next = 16;
          return takeEvery(GO_TO_NEXT_PRONUNCIATION_ITEM, goToNextPronunciationItemSaga);

        case 16:
          _context25.next = 18;
          return takeEvery(PRONUNCIATION_ITEM_ATTEMPTED, pronunciationItemAttemptedSaga);

        case 18:
          _context25.next = 20;
          return takeEvery(ACTIVITY_STEP_TRY_AGAIN_SELECTED, activityStepTryAgainSelectedSaga);

        case 20:
          _context25.next = 22;
          return takeEvery(SUBMIT_ACTIVITY_STEP, activityStepCheckAnswer);

        case 22:
          _context25.next = 24;
          return takeEvery(ACTIVITY_STEP_DISMISSED, activityStepDismissedSaga);

        case 24:
          _context25.next = 26;
          return takeEvery(ACTIVITY_STEP_MEDIA_STARTED, activityStepMediaStarted);

        case 26:
          _context25.next = 28;
          return takeEvery(ACTIVITY_STEP_MEDIA_PAUSED, activityStepMediaPaused);

        case 28:
          _context25.next = 30;
          return takeEvery(ACTIVITY_STEP_MEDIA_FINISHED, activityStepMediaFinished);

        case 30:
          _context25.next = 32;
          return takeEvery(ACTIVITY_STEP_UPLOAD_STARTED, activityStepUploadStarted);

        case 32:
          _context25.next = 34;
          return takeEvery(ACTIVITY_STEP_UPLOAD_FINISHED, activityStepUploadFinished);

        case 34:
          _context25.next = 36;
          return takeEvery(ACTIVITY_STEP_UPLOAD_FAILED, activityStepUploadFailed);

        case 36:
          _context25.next = 38;
          return takeEvery(sreActions.SRE_OPEN_CALIBRATE_WIN, activityStepCalibrationStarted);

        case 38:
          _context25.next = 40;
          return takeEvery(sreActions.SRE_CALIBRATE_COMPLETE, activityStepCalibrationPerformed);

        case 40:
          _context25.next = 42;
          return takeEvery(sreActions.SRE_CALIBRATE_ERROR, activityStepCalibrationErrored);

        case 42:
          _context25.next = 44;
          return takeEvery(sreActions.SRE_CLOSE_CALIBRATE_WIN, activityStepCalibrationFinished);

        case 44:
          _context25.next = 46;
          return takeEvery(LEARNING_ACTIVITY_INTERRUPTED, learningActivityInterruptedSaga);

        case 46:
          _context25.next = 48;
          return takeEvery(LEARNING_ACTIVITY_RESUMED, learningActivityResumedSaga);

        case 48:
        case 'end':
          return _context25.stop();
      }
    }
  }, _marked25, this);
}